<template>
  <div class="dashboard">
    <div class="dashboard-show">
      <div class="current-status">
        <div class="focus-row">
          <div class="box waiting">
            <div class="icon">
              <i class="las la-hourglass-half"></i>
              <div class="title">waiting for result</div>
            </div>
            <div class="number">49</div>
          </div>
          <div class="box offering">
            <div class="icon">
              <i class="las la-thumbs-up"></i>
              <div class="title">offering</div>
            </div>
            <div class="number">34</div>
          </div>
          <div class="box employed">
            <div class="icon">
              <i class="las la-trophy"></i>
              <div class="title">employed</div>
            </div>
            <div class="number">25</div>
          </div>
        </div>
        <div class="normal-row">
          <div class="box reviewing">
            <div class="icon">
              <div class="icon-shape">
                <i class="las la-glasses"></i>
              </div>
              <div class="title">reviewing</div>
            </div>
            <div class="number">36</div>
          </div>
          <div class="box selection">
            <div class="icon">
              <div class="icon-shape">
                <i class="las la-project-diagram"></i>
              </div>
              <div class="title">under selection</div>
            </div>
            <div class="number">19</div>
          </div>
          <div class="box request">
            <div class="icon">
              <div class="icon-shape">
                <i class="las la-comment-dots"></i>
              </div>
              <div class="title">interview request</div>
            </div>
            <div class="number">8</div>
          </div>
          <div class="box scheduled">
            <div class="icon">
              <div class="icon-shape">
                <i class="las la-user-friends"></i>
              </div>
              <div class="title">interview scheduled</div>
            </div>
            <div class="number">45</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardHome",
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.dashboard {
  .dashboard-show {
    margin-bottom: 2rem;
    .current-status {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      padding: 1rem 0;
      .box {
        display: flex;
        border-radius: 25px;
        color: $white;
        display: flex;
        height: auto;
        width: 100%;
      }
      .focus-row {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .box {
          width: 32%;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 2rem 1.5rem;
          margin-bottom: 1rem;
          .icon {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            i {
              font-size: 50px;
              opacity: 0.8;
              margin-right: 10px;
            }
            .title {
              font-size: 14px;
              font-weight: 500;
              text-transform: uppercase;
            }
          }

          .number {
            font-size: 50px;
            font-weight: 700;
          }
        }
      }
      .normal-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1.5rem 1rem;
        background: #f4f4f4;

        /* fallback */
        background-image: linear-gradient(320deg, #efefef, #f2f2f2);

        .box {
          width: 24%;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 1.5rem;
          background: #fafafa;
          .icon {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .icon-shape {
              width: 35px;
              height: 35px;
              margin-bottom: 4px;
              padding: 2px 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 12px;
              i {
                font-size: 26px;
              }
            }

            .title {
              font-size: 12px;
              font-weight: 500;
              text-transform: uppercase;
              color: $black;
            }
          }

          .number {
            font-size: 40px;
            font-weight: 700;
            color: $black;
          }
        }
      }

      //Focus Row

      .employed {
        background: #00c11d;

        /* fallback */
        background-image: linear-gradient(to top, #00c11d, #26d570);
      }
      .offering {
        background: #3742fa;

        /* fallback */
        background-image: linear-gradient(to top, #3742fa, #555efa);
      }
      .waiting {
        background: #1fb1ff;

        /* fallback */
        background-image: linear-gradient(to top, #1fb1ff, #25ccf7);
      }

      //Normal Row

      .scheduled {
        .icon-shape {
          background: #a55eea;
        }
      }

      .reviewing {
        .icon-shape {
          background: #f1c40f;
        }
      }

      .selection {
        .icon-shape {
          background: #f76400;
        }
      }
      .request {
        .icon-shape {
          background: #ff5c74;
        }
      }
    }

    .lastest-update {
      .table {
        padding: 1.5rem 0;
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .dashboard {
    .dashboard-title {
      font-size: 1.25em;
    }

    .dashboard-show {
      margin-bottom: 1rem;
      .current-status {
        padding: 1rem 0;
        .focus-row {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;

          .box {
            width: 100%;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .icon {
              i {
                font-size: 40px;
                margin-right: 10px;
              }
              .title {
                font-size: 14px;
              }
            }

            .number {
              font-size: 45px;
            }
          }
        }
        .normal-row {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          width: 100%;
          padding: 1.5rem 1rem;

          .box {
            width: 100%;
            padding: 1.5rem;
            margin-bottom: 15px;
            &.box:last-child {
              margin-bottom: 0;
            }
            .icon {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .icon-shape {
                width: 40px;
                height: 40px;
                margin-bottom: 4px;
                padding: 2px 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 12px;
                i {
                  font-size: 26px;
                }
              }

              .title {
                font-size: 12px;
              }
            }

            .number {
              font-size: 40px;
            }
          }
        }

        //Focus Row

        .employed {
          background: #00c11d;

          /* fallback */
          background-image: linear-gradient(to top, #00c11d, #26d570);
        }
        .offering {
          background: #3742fa;

          /* fallback */
          background-image: linear-gradient(to top, #3742fa, #555efa);
        }
        .waiting {
          background: #1fb1ff;

          /* fallback */
          background-image: linear-gradient(to top, #1fb1ff, #25ccf7);
        }

        //Normal Row

        .scheduled {
          .icon-shape {
            background: #a55eea;
          }
        }

        .reviewing {
          .icon-shape {
            background: #f1c40f;
          }
        }

        .selection {
          .icon-shape {
            background: #f76400;
          }
        }
        .request {
          .icon-shape {
            background: #ff5c74;
          }
        }
      }

      .lastest-update {
        .table {
          padding: 1.5rem 0;
        }
      }
    }
  }
}
</style>
